import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RefreshTokenResponse } from '../models/refresh-token-response.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  refreshToken(token: string): Observable<RefreshTokenResponse> {
    const body = {
      'refreshToken': token,
    };
    return this.http.post<RefreshTokenResponse>(`${environment.baseUrl}/auth/refresh-token`, body);
  }
}
